/**
 * Return time as "HH:mm" from given date.
 */
export function dateToTimeString(date: Date): string {
  const timeParts = date.toLocaleTimeString('et-EE').split(':');

  return `${timeParts[0]}:${timeParts[1]}`;
}